// extracted by mini-css-extract-plugin
module.exports = {"review":"_3ea6fa5da8--review--USJU9","review--refused":"_3ea6fa5da8--review--refused--LqRlV","review_view_all":"_3ea6fa5da8--review_view_all--IA8Ok"};